import api from './api';

// Get all timelines
const getTimelines = async () => {
  const response = await api.get('/api/timelines');
  return response.data;
};

// Get a specific timeline
const getTimelineById = async (id) => {
  const response = await api.get(`/api/timelines/${id}`);
  return response.data;
};

// Create a new timeline
const createTimeline = async (timelineData) => {
  const response = await api.post('/api/timelines', timelineData);
  return response.data;
};

// Update a timeline
const updateTimeline = async (id, timelineData) => {
  const response = await api.put(`/api/timelines/${id}`, timelineData);
  return response.data;
};

// Delete a timeline
const deleteTimeline = async (id) => {
  const response = await api.delete(`/api/timelines/${id}`);
  return response.data;
};

const timelineService = {
  getTimelines,
  getTimelineById,
  createTimeline,
  updateTimeline,
  deleteTimeline,
};

export default timelineService; 